import API from "../API";

function parseAgeRange(ageFilter) {
  if (!ageFilter) {
    return { minAge: "", maxAge: "" };
  }

  const match = String(ageFilter).match(/(\d+)\s*-\s*(\d+)/);
  if (match) {
    return {
      minAge: match[1],
      maxAge: match[2],
    };
  }

  const adultMatch = String(ageFilter).match(/(\d+)\s*\+/);
  if (adultMatch) {
    return {
      minAge: adultMatch[1],
      maxAge: "",
    };
  }

  return { minAge: "", maxAge: "" };
}

function buildProductsQuery(payload = {}, defaultSize = 10) {
  const { minAge, maxAge } = parseAgeRange(payload?.ageFilter);

  const params = new URLSearchParams({
    page: String(payload?.page ?? 0),
    size: String(payload?.size ?? defaultSize),
    sortBy: payload?.sortBy || "",
    sortDir: payload?.sortDir || "",
    search: payload?.search || "",
    minPrice: String(payload?.minPrice ?? ""),
    maxPrice: String(payload?.maxPrice ?? ""),
    categoryType: String(payload?.categoryType ?? ""),
    minAge: String(payload?.minAge ?? minAge ?? ""),
    maxAge: String(payload?.maxAge ?? maxAge ?? ""),
    gender: payload?.gender || payload?.genderFilter || "",
    customFilter: payload?.customFilter || payload?.themeFilter || "",
    isActive: "true",
  });

  return params.toString();
}

export const GetProductCategoriesApi = async (payload) => {
  try {
    const response = await API.get(`/ecommerce/product/categories`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetAllProductsApi = async (payload) => {
  try {
    const response = await API.get(
      `/ecommerce/api/products/all?${buildProductsQuery(payload, 10)}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetAllProductsInfintieApi = async (payload) => {
  try {
    const response = await API.get(
      `/ecommerce/api/products/all?${buildProductsQuery(payload, 1000)}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetSingleProductsApi = async (payload) => {
  try {
    const response = await API.get(
      `/ecommerce/api/product/${payload?.productId || ""}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const multipleFileUploadApi = async (payload) => {
  try {
    const formData = new FormData();

    payload.files.forEach((file) => {
      formData.append("files", file); // important
    });
    if (payload?.productId) {
      formData.append("productId", payload?.productId.toString());
    }

    console.log("formData ", formData, payload.files);

    const response = await API.post(
      `/ecommerce/api/product/upload/files`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteFileApi = async (payload) => {
  try {
    const response = await API.delete(
      `/ecommerce/api/product/file?key=${payload?.key || ""}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};
